export const REPLY_RECOMMENDATIONS_HISTORY = ['replyRecommendationsHistory'];